import ArticlePage from "@/pages/article/ArticlePage";
import { allArticles } from "@/mocks/articles";

export default function SneakersArticle() {
  return <ArticlePage article={allArticles["allchinabuy-spreadsheet-sneakers"]} />;
}